import { ExternalLink } from "lucide-react";

/**
 * Ekosistem banner — "Biz Birlikte Daha Güçlüyüz!"
 * Serdar Ceylan'ın kurduğu 4 markayı bir görsel altında birleştirir.
 * Görsel üzerinde her karakterin bulunduğu bölge tıklanabilirdir.
 */
const BRANDS = [
  {
    key: "pedizone",
    name: "PediZone",
    tagline: "Ayak Sağlığı Ürünleri",
    href: "https://pedizone.com/",
    // Yüzdesel konum (görseldeki karakterin yaklaşık kapsadığı alan)
    hotspot: { left: 22, top: 28, width: 12, height: 60 },
    color: "#DC2626", // kırmızı — Pedizone
  },
  {
    key: "medipodo",
    name: "MediPodo",
    tagline: "Podoloji Hizmetleri",
    href: "https://medipodo.com/",
    hotspot: { left: 39, top: 28, width: 14, height: 60 },
    color: "#2563EB", // mavi — Medipodo
  },
  {
    key: "medieste",
    name: "MediEste",
    tagline: "Sağlıklı Güzellik",
    href: "/",
    hotspot: { left: 56, top: 28, width: 12, height: 60 },
    color: "#10B981", // yeşil — MediEste
    self: true,
  },
  {
    key: "ayaktakip",
    name: "AyakTakip",
    tagline: "Akıllı Takip · Sağlıklı Adımlar",
    href: "https://ayaktakip.com/",
    hotspot: { left: 73, top: 20, width: 14, height: 68 },
    color: "#0EA5E9", // açık mavi — Ayaktakip
  },
];

export default function Ekosistem() {
  return (
    <section data-testid="ekosistem-section" className="py-20 md:py-28 bg-white border-t border-[#E5EAF0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 max-w-3xl mx-auto">
          <p className="chip mb-4 mx-auto">Ekosistem</p>
          <h2 className="font-display text-3xl md:text-5xl text-[#0B1B33] leading-[1.1] tracking-tight mb-4">
            Biz Birlikte Daha Güçlüyüz
          </h2>
          <p className="text-[#4B5A6E] leading-relaxed">
            Podolog Serdar Ceylan öncülüğünde kurulan 4 marka; ayak sağlığından güzelliğe, ürün geliştirmeden dijital takibe kadar bütüncül bir sağlık ekosistemi oluşturuyor.
          </p>
        </div>

        <div className="relative rounded-3xl overflow-hidden shadow-xl bg-[#F5F7FA]">
          <img
            src="/upload/ekosistem/ekosistem-serdar-ceylan.webp"
            alt="MediEste, MediPodo, PediZone ve AyakTakip — Biz Birlikte Daha Güçlüyüz!"
            className="w-full h-auto block"
            loading="lazy"
          />

          {/* Clickable hotspots — percentage-positioned, fully responsive */}
          {BRANDS.map((b) => (
            <a
              key={b.key}
              href={b.href}
              target={b.self ? undefined : "_blank"}
              rel={b.self ? undefined : "noreferrer"}
              data-testid={`ekosistem-hotspot-${b.key}`}
              aria-label={`${b.name} - ${b.tagline}`}
              className="group absolute rounded-2xl transition-all duration-300 hover:bg-white/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#10B981]"
              style={{
                left: `${b.hotspot.left}%`,
                top: `${b.hotspot.top}%`,
                width: `${b.hotspot.width}%`,
                height: `${b.hotspot.height}%`,
              }}
            >
              <span className="sr-only">{b.name}</span>
            </a>
          ))}
        </div>

        {/* Below-image quick access cards (also serve as visible link cues on mobile) */}
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {BRANDS.map((b) => (
            <a
              key={`btn-${b.key}`}
              href={b.href}
              target={b.self ? undefined : "_blank"}
              rel={b.self ? undefined : "noreferrer"}
              data-testid={`ekosistem-card-${b.key}`}
              className="group bg-white border border-[#E5EAF0] rounded-2xl p-4 md:p-5 hover:shadow-lg hover:-translate-y-0.5 transition-all"
              style={{ borderTop: `3px solid ${b.color}` }}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="font-display font-semibold text-[#0B1B33] text-base md:text-lg">{b.name}</span>
                {!b.self ? <ExternalLink size={14} className="text-[#7C8CA0] group-hover:text-[#0E2B4F]" /> : null}
              </div>
              <p className="text-xs md:text-[13px] text-[#4B5A6E] leading-snug">{b.tagline}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
